import { useTranslation } from 'react-i18next';
import { SttPage } from '../../../sporttia/all';
import { useCloseToPreviousPage } from '../../../lib/hooks/useCloseToPreviousPage';
import CapacityMonitorContent from './CapacityMonitorContent';

/**
 * Monitor de aforo con su propia URL: una página del gestor, con el sidebar y la
 * cabecera compartida, para que se pueda abrir en otra pestaña o ventana y
 * ocupe la pantalla completa. La flecha de la cabecera vuelve a donde se
 * estaba, o al cuadrante si se entró directamente por la URL.
 */
export default function CapacityMonitorPage(): React.ReactElement {
    const { t } = useTranslation();
    const close = useCloseToPreviousPage();

    return (
        <SttPage title={t('deviceSpace.devicesCapacityMonitor')} onBack={close}>
            <CapacityMonitorContent />
        </SttPage>
    );
}
